<template>
  <v-layout
    text-left
    align-center
    wrap
    ver
  >
    <v-flex xs4 style="padding:10px;">
      <v-img
        :src="data.Image"
        class="my-3"
        contain
        height="auto"
        style="border-radius: 50%; border: 1px solid #ccc;"
      />
    </v-flex>
    <v-flex xs8 style="padding: 10px;">
      <p style="margin-top:10px;margin:2px 0;" 
        :style="{ 
          'color': BGColorSecundary,
          'font-size': `${(FontSizeContent + 5)}px`,
          'font-family': FontContent,
        }"
      >
          {{data.Title}}
      </p>
      <p
        style="margin:2px 0;" 
        :style="{ 
          'color': ColorContent && ColorContent.length >= 7 ? ColorContent.substring(0, 7).concat('80') : '#CCCCCC',
          'font-size': `${(FontSizeContent)}px`,
          'font-family': FontContent,
        }"
      >
        {{data.SubTitle}}
      </p>
      <p
        v-if="phone && phone.length > 0"
        style="margin:15px 0;" 
        :style="{ 
          'color': ColorContent && ColorContent.length >= 7 ? ColorContent.substring(0, 7).concat('80') : '#CCCCCC',
          'font-size': `18px`,
          'font-family': FontContent,
        }"
      >
        <v-icon style="margin-right:10px;">mdi-phone</v-icon><a :href="`tel:${phone}`"
          style="text-decoration: none;"
          :style="{ 'color':  ColorContent && ColorContent.length >= 7 ? ColorContent.substring(0, 7).concat('80') : '#CCCCCC' }"
        >{{phone}}</a>
      </p>
    </v-flex>
    <v-flex xs12 v-if="isSimulation || !isDesktop">
      <v-divider />
    </v-flex>
</v-layout>
</template>

<script>
  import constants from '@/constants'
  import utils from '@/services/utils'
  export default {
    props: {
      data: {
        type: Object,
        required: true
      },
    },
    data: () => ({
    }),
    computed: { 
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop () {
        return !utils.isMobile();
      },
      ColorContent () {
        return this.$store.state.app.ColorContent
      },
      BGColorSecundary () {
        return this.$store.state.app.BGColorSecundary
      },
      FontContent () {
        return this.$store.state.app.FontContent
      },
      FontSizeContent () {
        return this.$store.state.app.FontSizeContent
      },
      phone () {
        return this.data.Price.replace('Tel. ', '')
      }
    },
    mounted () {
    },
    methods: {
      
    }
  }
</script>
